import React, { useEffect } from 'react';

import { BUTTON_BORDER_RADIUS, PRIMARY_COLOR, SECONDARY_COLOR } from '../constants/style-constants';
import { useCommon } from '../../store/CommonContext';

import './Button.css';
import { redirectToDecline, redirectToSuccess } from '../../helpers/parent-helper';
import { useHref, useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icons from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Image from '../image/Image';

interface Props {
  text?: string;
  additionalClasses?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  onClick?: () => void;
  attributes?: { [key: string]: string };
  dataid?: string | null;
  disabled: boolean;
  backgroundColor?: string;
  iconColor?: string;
  color?: string;
  fontAwesomeIcon?: keyof typeof icons;

  imageBase64?: string;
  imageUrl?: string;
  imageName?: string;

  href?: string;
  target?: string;
}

const Button: React.FC<Props> = props => {
  const {
    text,
    onClick,
    type,
    additionalClasses = '',
    attributes = [],
    dataid,
    disabled,
    imageBase64,
    imageName,
    imageUrl,
    backgroundColor,
    color,
    iconColor,
    fontAwesomeIcon,
    href,
    target,
  } = props;
  const [buttonText, setButtonText] = React.useState(text);
  const {
    state: { configuration, challengeTemplate },
  } = useCommon();
  const navigate = useNavigate();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // if (attributes?.id === 'ui-widget-challenge-button') {
    if (additionalClasses.includes('ui-widget-button-counter')) {
      let counter = 10;
      const interval = setInterval(() => {
        if (counter === 0) {
          clearInterval(interval);
          if (challengeTemplate?.parameters?.Redirect === 'Approve') {
            redirectToSuccess();
          }
          if (challengeTemplate?.parameters?.Redirect === 'Decline') {
            redirectToDecline(navigate);
          }
        } else {
          setButtonText(`${text} (${counter})`);
        }
        counter -= 1;
      }, 1000);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  }, [attributes.id]);

  // configuration = { isLogoVisible: true };
  // console.log('configuration---', configuration);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      event.preventDefault();
      if (target === '_blank') {
        window.open(href, '_blank');
      } else {
        navigate(href);
      }
      return;
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      disabled={disabled}
      className={`ui-widget-button ${additionalClasses}`}
      style={{
        ...(backgroundColor && { backgroundColor }),
        ...(typeof configuration?.buttonsCornersRadius === 'string' ||
        typeof configuration?.buttonsCornersRadius === 'number'
          ? { borderRadius: configuration.buttonsCornersRadius }
          : {}),
        ...(color && { color }),
      }}
      onClick={handleClick}
      type={type}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dataid={dataid}
      {...attributes}
    >
      {fontAwesomeIcon && (
        <FontAwesomeIcon
          icon={icons[fontAwesomeIcon] as IconProp}
          className="ui-widget-button-icon"
          style={{
            ...(iconColor && { color: iconColor }),
            ...(color && !iconColor && { color }),
            ...(typeof configuration?.secondaryColor === 'string' &&
              !iconColor &&
              !color && { color: configuration.secondaryColor }),
          }}
        />
      )}
      {/*{imageUrl && <img className="ui-widget-button-image" src={imageUrl} alt="button" />}*/}
      {/*{imageUrl && <img className="ui-widget-button-image" src={imageUrl} alt="button" />}*/}
      {/*{!imageUrl && imageBase64 && <img className="ui-widget-button-image" src={imageBase64} alt="button" />}*/}
      {/*{!imageUrl && !imageBase64 && buttonText}*/}
      <Image imageUrl={imageUrl} classes={['ui-list-icon']} imageBase64={imageBase64} imageName={imageName} />
      {buttonText || text}
    </button>
  );
};

export default Button;
